// extracted by mini-css-extract-plugin
export default {"head_container":"IRISCompanyProfileIRF_head_container__-3UCU","headingBackground":"IRISCompanyProfileIRF_headingBackground__eJxjY"};